<script>
import globalMixin from '../mixins/global';

export default {
  name: 'App',
  //props: ['currentRoute'],
  data: function() {
    return {
      currentRoute: window.location.pathname
    }
  },
  mixins: [globalMixin],
  /*data: {
    currentRoute: window.location.pathname
  },*/
  watch:{
    $route (to, from){
      this.currentRoute = window.location.pathname
    }
  }
}
</script>

<template>
  <div v-show="currentRoute=='/' || currentRoute=='/types/'">
    <div class="col-md-10 col-md-offset-1 padding-top-2">
      <h1 class="h1-alt d2lOrange-semi-line margin-bottom-2">My Type Quizzes</h1>
      <div class="col-md-12 no-padding-x padding-bottom" v-for="route in $router.options.routes" :key="route.path">
        
        <div v-if="route.path != '/'">
          <div v-if="route.display_homepage">
            <p class="no-margin-bottom">
              <a :href="route.path">
                <span class="btn pill">{{route.name}}</span>
              </a>
            </p>
            <p class="margin-top">{{route.description}}</p>
          </div>
          
          <div v-else>
            <p class="no-margin-bottom">
              <a :href="route.path">
                <span class="btn pill">{{route.name}}</span>
              </a>
            </p>
            <p class="margin-top">{{route.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>